"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFontSelects = addFontSelects;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _hsformatting = require("tinymce-plugins/constants/hsformatting");

var _utils = require("../utils");

var _toolbar = require("../constants/toolbar");

var _usageTracking = require("../constants/usageTracking");

var _usageTracking2 = require("../utils/usageTracking");

var _formatting = require("../utils/formatting");

var _TinyMceFontSelect = _interopRequireDefault(require("../components/toolbar/TinyMceFontSelect"));

var _getComputedStyle = require("../utils/getComputedStyle");

var _hsformatting2 = require("../constants/hsformatting");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting2.i18nNameSpace);

function createFontSelectHandler(editor, method) {
  return function (event) {
    var format = event.control.settings.value;

    if (format) {
      editor.execCommand('hsfontselect', false, {
        value: format
      });
      (0, _usageTracking2.trackInteraction)(editor, 'tinymceFormatting', _usageTracking.CHANGE_FONT, {
        method: method,
        value: format
      });
    }
  };
}

function createFontSelectMenu(editor) {
  var fontFormats = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.FONT_FORMATS);
  var webfontFormats = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.WEBFONT_FORMATS);
  var options = Object.keys(fontFormats).sort().map(function (font) {
    return {
      text: {
        raw: font
      },
      value: fontFormats[font],
      textStyle: "font-family: " + fontFormats[font]
    };
  });

  if (webfontFormats && Object.keys(webfontFormats).length > 0) {
    var webfontOptions = Object.keys(webfontFormats).map(function (webfont) {
      return {
        text: {
          raw: webfont
        },
        value: webfontFormats[webfont],
        textStyle: "font-family: " + webfontFormats[webfont] + "; margin-left: 1rem"
      };
    });
    var webfontsHeader = {
      text: {
        raw: i18nKey('webfontsHeader')
      },
      value: '',
      classes: 'subtitle new-section'
    };
    return [].concat((0, _toConsumableArray2.default)(options), [webfontsHeader], (0, _toConsumableArray2.default)(webfontOptions));
  }

  return options;
}

function createPostRenderHandler(items, editor) {
  return function (_ref) {
    var control = _ref.control;
    // Reset the value to null to override the default tinymce behavior
    // of selecting the first item
    control.value(null);
    editor.on('NodeChange', function (event) {
      var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(editor.getWin(), event.element);

      if (!computedStyle) {
        return;
      }

      var fontFamily = (0, _formatting.normalizeFontStack)(computedStyle['font-family']);
      var matched = items.find(function (item) {
        return (0, _formatting.normalizeFontStack)(item.value) === fontFamily;
      });

      if (matched) {
        control.value(matched.value);
      } else {
        control.value(null);
      }
    });
  };
}

function addFontSelects(editor) {
  var fonts = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.FONT_FORMATS);
  var webfonts = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.WEBFONT_FORMATS);
  editor.addMenuItem('fontselect', {
    text: i18nKey('fontSelectMenuItem'),
    menu: createFontSelectMenu(editor).map(function (item) {
      item.onclick = createFontSelectHandler(editor, 'menu');
      return item;
    })
  });
  editor.addCommand('hsfontselect', function (command, _ref2) {
    var value = _ref2.value;
    editor.formatter.apply('fontname', {
      value: value
    });
    editor.nodeChanged();
  });
  editor.addButton('fontselect', function () {
    var items = createFontSelectMenu(editor);
    var controlName = i18nKey('fontSelectToolbarButton');
    return {
      type: 'listbox',
      text: controlName,
      tooltip: controlName,
      values: items,
      fixedWidth: true,
      onPostRender: createPostRenderHandler(items, editor),
      onselect: createFontSelectHandler(editor, 'button')
    };
  });
  editor.addButton('canvasfontselect', {
    type: _toolbar.CANVAS_BUTTON_TYPE,
    renderControl: function renderControl(props) {
      return _react.default.createElement(_TinyMceFontSelect.default, (0, _extends2.default)({
        editor: editor,
        fonts: (0, _formatting.getFontSelectOptions)(fonts),
        webfonts: (0, _formatting.getFontSelectOptions)(webfonts)
      }, props));
    }
  });
}